import debug from 'debug'

const log = debug('app:javascript/clients/event_relay/event_sender.js')

export class EventSender {
  constructor(url, tokenProvider) {
    this.url = url
    this.tokenProvider = tokenProvider
  }

  async send(events, options = {}) {
    if (!events || events.length === 0) {
      throw new Error('No events to send')
    }

    const token = await this.tokenProvider()
    if (!token) {
      throw new Error('No valid token available')
    }

    log(`Sending batch of ${events.length} events`)

    const fetchOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ events }),
      keepalive: options.keepalive || false,
    }

    const response = await fetch(this.url, fetchOptions)

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }

    const result = await response.json()
    log(result)
    return result
  }
}
